/* ============
 * Organization Conf Mutations
 * ============
 *
 * The mutations available for the organization conf module.
 */

export const CONF = 'CONF';
export const DOC_TYPES = 'DOC_TYPES';
export const ADD_PARSER = 'ADD_PARSER';
export const UPDATE_PARSERS = 'UPDATE_PARSERS';
export const REMOVE_PARSER = 'REMOVE_PARSER';
export const UPDATE_EXTRA_OPTIONS = 'UPDATE_EXTRA_OPTIONS';
export const ADD_DOCTYPES_WITHSTORAGE = 'ADD_DOCTYPES_WITHSTORAGE';
export const REMOVE_DOCTYPES_WITHSTORAGE = 'REMOVE_DOCTYPES_WITHSTORAGE';
export const UPDATE_DISPATCH_VALIDATION = 'UPDATE_DISPATCH_VALIDATION';

export default {
  CONF,
  DOC_TYPES,
  ADD_PARSER,
  UPDATE_PARSERS,
  REMOVE_PARSER,
  UPDATE_EXTRA_OPTIONS,
  ADD_DOCTYPES_WITHSTORAGE,
  REMOVE_DOCTYPES_WITHSTORAGE,
  UPDATE_DISPATCH_VALIDATION,
};



// WEBPACK FOOTER //
// ./src/store/modules/organization-conf/mutation-types.js